import React from 'react';
import ParcelDetails from './ParcelDetails';
import ParcelDetailsButtons from './ParcelDetailsButtons';
import type { Parcel } from '../types';
import { useZoomToParcelOnLoad } from '../hooks';
import Pager from './Pager';

interface ParcelDetailsViewProps {
  parcel: Parcel | undefined;
  isLoading: boolean;
}

const ParcelDetailsView: React.FC<ParcelDetailsViewProps> = ({ parcel, isLoading }) => {
  useZoomToParcelOnLoad(parcel, isLoading)

  return (
    <div className="container">
      <Pager />
      <ParcelDetailsButtons parcel={parcel} />
      {isLoading &&
        <div className="side-bar-loader">
          <i className='fa fa-spinner fa-spin'></i>
          <span>LOADING</span>
        </div>}
      {!isLoading && parcel && <ParcelDetails parcel={parcel} />}
    </div>
  );
};

export default ParcelDetailsView;